import React, { useEffect } from 'react';
import Flow from 'components/Common/Flow/Flow';
import { useDispatch, useSelector } from 'react-redux';
import getAddingToCartFlow from 'store/product/selector/getAddingToCartFlow';
import { AddToCartFlow } from 'store/product/types';
import { AvailableFlows } from 'store/app/types';
import { nextStepFlowAction } from 'store/app/slice';
import redirectToApiEditorOperation from 'store/app/operation/redirectToApiEditorOperation';
import useIsServer from 'hooks/useIsServer';

const CuratedWallpaperPostAddToCartFlow = () => {
  const currentAddToCartFlow = useSelector(getAddingToCartFlow);

  const dispatch = useDispatch();
  const isServer = useIsServer();
  if (isServer) {
    return null;
  }

  useEffect(() => {
    if (currentAddToCartFlow === AddToCartFlow.addedToCart) {
      dispatch(nextStepFlowAction(AvailableFlows.postAddToCart));
    }
  }, [currentAddToCartFlow]);

  const goToEditor = async () => {
    dispatch(redirectToApiEditorOperation());
  };

  return (
    <>
      <Flow flowId={AvailableFlows.postAddToCart} flowSteps={[goToEditor]} />
    </>
  );
};

export default CuratedWallpaperPostAddToCartFlow;
